type LanguageList = { label: string; value: string; active: boolean };
export const LANGUAGE_LIST: LanguageList[] = [
  {
    label: 'English',
    value: 'en-us',
    active: true,
  },
  {
    label: 'German',
    value: 'de-de',
    active: true,
  },
  {
    label: 'فارسی',
    value: 'fa-ir',
    active: true,
  },
  {
    label: 'Français',
    value: 'fr-fr',
    active: true,
  },
  {
    label: '日本語',
    value: 'ja-jp',
    active: true,
  },
  {
    label: '한국어',
    value: 'ko-kr',
    active: true,
  },
  {
    label: 'Russian',
    value: 'ru-ru',
    active: true,
  },
  {
    label: 'Spanish',
    value: 'es-es',
    active: true,
  },
];
